import { render } from "./MainPopup.vue?vue&type=template&id=9400a4e4&scoped=true"
import script from "./MainPopup.vue?vue&type=script&lang=js"
export * from "./MainPopup.vue?vue&type=script&lang=js"

import "@/assets/css/components/mainPopup.css?vue&type=style&index=0&id=9400a4e4&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9400a4e4"]])

export default __exports__